import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function updateDispositionCall(requestObject) {
  validateUserKey(requestObject.UserKey);
  try {
    const { data } = await apiClient.patch("api/updateCallDisposition", requestObject, {
      headers: {
        "x-user-key": requestObject.UserKey,
      },
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
